import { render, staticRenderFns } from "./imageItemForCheck.vue?vue&type=template&id=5b2bd240&scoped=true&"
import script from "./imageItemForCheck.vue?vue&type=script&lang=js&"
export * from "./imageItemForCheck.vue?vue&type=script&lang=js&"
import style0 from "./imageItemForCheck.vue?vue&type=style&index=0&id=5b2bd240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2bd240",
  null
  
)

export default component.exports